// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_1Ns6_","listWrap":"index_listWrap_3PqOk","p20":"index_p20_3c-h9","search":"index_search_1hXCz","gap20":"index_gap20_6Q90P","action":"index_action_1jQfq"};